export default {
  name: { defaultValue: '' },
  short_name: { defaultValue: '' }
}
